import { StyleSheet, Platform, Dimensions } from 'react-native';

const width = Dimensions.get('window').width
console.log(width)

export default StyleSheet.create({
    backdrop: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0,
        backgroundColor: 'black',
    },
    content: {
        flex: 1,
        justifyContent: 'center',
        ...Platform.select({
            web: {
                maxWidth: 600,
                alignSelf: width >= 600 ? 'center' : 'auto',
                minWidth: width > 600 ? width + 300 : width
            }
        })
    },
    containerBox: {
        zIndex: 2,
        opacity: 1,
        backgroundColor: 'transparent',
    },
});
